// styles
import "../css/main.scss";

// Require dependencies
import $ from "jquery";
import { cleanHtml, ensoPasteCleanup } from "./enso-html-cleanup.js";
import Cookies from "js-cookie";
import _ from "underscore";
import Backbone from "backbone";

import { KEYCODES } from "./third-party.js";
import {
  openFormModal,
  getMimeObject,
  stripExtension,
  crossDomainAjax
} from "./enso-plugins.js";

var $fullscreenSpinner = $(".fullscreen-spinner");

function start_fullscreen_spinner() {
  $fullscreenSpinner.show();
}

function stop_fullscreen_spinner() {
  $fullscreenSpinner.hide();
}

const ALLOWED_FILE_TYPES = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "audio/m4a",
  "audio/mp3",
  "audio/mpeg",
  "audio/x-m4a",
  "video/mp4",
  "audio/wav",
  "audio/x-wav",
  "audio/aac",
  "application/zip"
];

/******************************************************************************
 ** utility functions
 ******************************************************************************/

function get_uuid() {
  //http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/******************************************************************************
 ** initialise server side generated javascript data
 ******************************************************************************/

var initial_data = {};
if (typeof initial_js_data !== "undefined") {
  initial_data = initial_js_data;
  //initial_js_data is generated server side and rendered to a <script> tag
  //below the end of <body> and just before loading of external js files
}

/******************************************************************************
 ** often used jquery lookups
 ******************************************************************************/

var $body = $("body");

function startMainLoading() {
  $body.addClass("loading");
}

function stopMainLoading() {
  $body.removeClass("loading");
}

/******************************************************************************
 ** get Jquery to always send a CSRF token with each POST request
 ******************************************************************************/

// see https://docs.djangoproject.com/en/dev/ref/contrib/csrf/#ajax

var csrftoken = Cookies.get("csrftoken");

function csrfSafeMethod(method) {
  // these HTTP methods do not require CSRF protection
  return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
}
$.ajaxSetup({
  crossDomain: false, // obviates need for sameOrigin test
  beforeSend: function(xhr, settings) {
    if (!csrfSafeMethod(settings.type)) {
      xhr.setRequestHeader("X-CSRFToken", csrftoken);
    }
  }
});

/******************************************************************************
 ** site-wide Backbone Events
 ******************************************************************************/

var globalEvents = {};
_.extend(globalEvents, Backbone.Events);

/******************************************************************************
 ** Backbone models
 ******************************************************************************/

var BaseModel = Backbone.Model.extend({
  destroyLocalOnly: function() {
    this.trigger("destroy", this); //trigger destroy event without sending a DELETE request to the server
  }
});

var AssetModel = BaseModel.extend({
  urlRoot: "/api/core/assets/"
});

var ImageAssetModel = BaseModel.extend({
  urlRoot: "/api/core/imageassets/"
});

var AudioAssetModel = BaseModel.extend({
  urlRoot: "/api/core/audioassets/"
});

var VideoAssetModel = BaseModel.extend({
  urlRoot: "/api/core/videoassets/"
});

var MakerModel = BaseModel.extend();

var CurrentlyDraggingObject = Backbone.Model.extend();

var Autoscroller = Backbone.Model.extend({
  /**
   * It's a Backone model just to use its Object Oriented features
   */

  initialize: function() {
    this.directions = ["UP", "DOWN", "LEFT", "RIGHT"];
    for (let direction of this.directions) {
      this[this.getIntervalName(direction)] = null;
    }
    this.SPEED = 10;
    this.FRAMERATE = 20;
  },

  getIntervalName: function(direction) {
    return "intervalScroll" + direction;
  },

  /**
   *
   * @param scrolling true | false
   * @param direction 'UP' | 'DOWN' | 'LEFT' | 'RIGHT'
   */
  changeState: function(scrolling, direction) {
    var model = this;
    var intervalName = this.getIntervalName(direction);
    direction = direction.toUpperCase();
    if (scrolling) {
      switch (direction) {
        case "UP":
          model[intervalName] = setInterval(function() {
            var scrollTop = $(document).scrollTop();
            $(document).scrollTop(scrollTop - model.SPEED);
          }, this.FRAMERATE);
          break;
        case "DOWN":
          model[intervalName] = setInterval(function() {
            var scrollTop = $(document).scrollTop();
            $(document).scrollTop(scrollTop + model.SPEED);
          }, this.FRAMERATE);
          break;
        case "LEFT":
          model[intervalName] = setInterval(function() {
            var scrollLeft = $(document).scrollLeft();
            $(document).scrollLeft(scrollLeft - model.SPEED);
          }, this.FRAMERATE);
          break;
        case "RIGHT":
          model[intervalName] = setInterval(function() {
            var scrollLeft = $(document).scrollLeft();
            $(document).scrollLeft(scrollLeft + model.SPEED);
          }, this.FRAMERATE);
          break;
      }
    } else {
      clearInterval(this[intervalName]);
    }
  }
});

/******************************************************************************
 ** Backbone collections
 ******************************************************************************/

var AssetCollection = Backbone.Collection.extend({
  model: AssetModel,
  url: "/api/core/assets/",

  parse: function(response) {
    return response.results;
  },

  initialize: function(models, options) {
    this.viewModel = options.viewModel;
  }
});

/******************************************************************************
 ** Backbone Views
 ******************************************************************************/

var BaseView = Backbone.View.extend({});

var BodyView = BaseView.extend({
  el: "body",

  initialize: function() {
    var view = this;
    this.dragging = false;

    this.currDraggingObjectView = null;
    this.VIEWPORT_EDGE_SIZE = 20;

    this.listenTo(globalEvents, "enso:startDragging", function(data) {
      view.dragging = true;
      $body.addClass("dragging");
      this.currDraggingObjectView = new CurrentlyDraggingObjectView(data);
    });

    this.autoscroller = new Autoscroller();
    this.initializeViewPortEdgeFunctionality();
  },

  events: {
    mousemove: function(e) {
      this.currX = e.pageX;
      this.currY = e.pageY;

      this.triggerViewPortEdgeEvents(e);

      if (this.dragging) {
        this.currDraggingObjectView.setPos(this.currX, this.currY);
      }
    },
    mouseup: function(e) {
      if (this.dragging) {
        globalEvents.trigger("enso:stopDragging");
        this.dragging = false;
        $body.removeClass("dragging");

        var data = this.currDraggingObjectView.options;
        this.currDraggingObjectView.remove(); //this must be removed BEFORE we get the mouseOverElement
        var $mouseOverElement = $($.elementFromPoint(e.clientX, e.clientY));
        data.$elementDroppedOn = $mouseOverElement;
        $mouseOverElement.trigger("enso:drop", data);
      }
    }
  },

  initializeViewPortEdgeFunctionality: function() {
    var view = this;
    this.EDGES = ["TOP", "RIGHT", "BOTTOM", "LEFT"];
    this.viewportEdgesMousePreviouslyAt = {};

    var getEventName = function(edge, direction) {
      return (
        "enso:mouse" +
        direction +
        "ViewportEdge" +
        edge.toLowerCase().capitalizeFirstLetter()
      );
    };

    var edgeDirectionMap = {
      TOP: "UP",
      BOTTOM: "DOWN",
      RIGHT: "RIGHT",
      LEFT: "LEFT"
    };

    for (let edge of this.EDGES) {
      let enterEventName = getEventName(edge, "Enter");
      let leaveEventName = getEventName(edge, "Leave");

      view.listenTo(globalEvents, enterEventName, function(eventName) {
        if (eventName == enterEventName && view.dragging == true) {
          view.autoscroller.changeState(true, edgeDirectionMap[edge]);
        }
      });
      view.listenTo(globalEvents, leaveEventName, function(eventName) {
        if (eventName == leaveEventName && view.dragging == true) {
          view.autoscroller.changeState(false, edgeDirectionMap[edge]);
        }
      });
      view.viewportEdgesMousePreviouslyAt[edge] = false;
    }
  },

  triggerViewPortEdgeEvents: function(e) {
    var view = this;
    this.viewportEdgesMouseCurrentlyAt = this.getViewportEdgesMouseCurrentlyAt(
      e
    );

    var mouseEnterViewportEdge = function(edge) {
      return (
        view.viewportEdgesMouseCurrentlyAt[edge] &&
        !view.viewportEdgesMousePreviouslyAt[edge]
      );
    };

    var mouseLeaveViewportEdge = function(edge) {
      return (
        !view.viewportEdgesMouseCurrentlyAt[edge] &&
        view.viewportEdgesMousePreviouslyAt[edge]
      );
    };

    for (let edge of this.EDGES) {
      var eventNames = [];
      if (mouseEnterViewportEdge(edge)) {
        eventNames.push(
          "enso:mouseEnterViewportEdge" +
            edge.toLowerCase().capitalizeFirstLetter()
        );
      }
      if (mouseLeaveViewportEdge(edge)) {
        eventNames.push(
          "enso:mouseLeaveViewportEdge" +
            edge.toLowerCase().capitalizeFirstLetter()
        );
      }
      _.each(eventNames, function(eventName) {
        globalEvents.trigger(eventName, eventName);
      });
    }

    view.viewportEdgesMousePreviouslyAt = view.viewportEdgesMouseCurrentlyAt;
  },

  getViewportEdgesMouseCurrentlyAt: function(mouseEvent) {
    this.cursorAtViewPortEdge = false;
    var e = mouseEvent;
    var width = this.getViewportWidth();
    var height = this.getViewportHeight();
    var x = e.clientX;
    var y = e.clientY;
    return {
      LEFT: x <= this.VIEWPORT_EDGE_SIZE && x >= 0,
      TOP: y <= this.VIEWPORT_EDGE_SIZE && y >= 0,
      RIGHT: x <= width && x >= width - this.VIEWPORT_EDGE_SIZE,
      BOTTOM: y <= height && y >= height - this.VIEWPORT_EDGE_SIZE
    };
  },

  getViewportHeight: function() {
    return $(window).height();
  },

  getViewportWidth: function() {
    return $(window).width();
  }
});

var getCropKeys = function() {
  var main_image_crop_data = initial_data.main_image_crop_data;
  if (typeof main_image_crop_data !== "undefined") {
    return Object.keys(main_image_crop_data);
  } else {
    return [];
  }
};

var getCropButtonSlug = function(cropKey) {
  return "js-crop-" + cropKey.replace(/\./g, "-") + "-btn";
};

var ForeignKeyWidgetEnhancementView = Backbone.View.extend({
  events: function() {
    var cropEventHandler = this.clickCropImageBtn;

    var cropButtonEvents = {};
    for (let cropKey of getCropKeys()) {
      cropButtonEvents[`click [${getCropButtonSlug(cropKey)}]`] = function(e) {
        cropEventHandler(this, e, cropKey);
      };
    }

    return Object.assign(
      {
        "click [js-new-foreign-key-btn]": "clickAddBtn",
        "click [js-edit-foreign-key-btn]": "clickEditBtn",
        "click [js-remove-foreign-key-btn]": "clickRemoveBtn",
        "enso:drop": "drop"
      },
      cropButtonEvents
    );
  },

  initialize: function(options) {
    var view = this;

    view.options = Object.assign({}, view.defaultOptions, options);
    view.foreignKeyView = view.options.foreignKeyView;
    view.options = view.foreignKeyView.options;
    view.listenTo(globalEvents, "enso:startDragging", view.startDragging);
    view.listenTo(globalEvents, "enso:stopDragging", view.stopDragging);
    view.render();
  },

  render: function() {
    var options = this.foreignKeyView.options;
    var context = {
      showEditBtn: options.showEditBtn,
      showAddBtn: options.showAddBtn,
      showRemoveBtn: options.showRemoveBtn
    };

    if (this.model == null) {
      context.model = null;
    } else {
      context.model = this.model.toJSON();
    }

    var tmpl = require("../nunjucks-templates/widgets/foreign-key-widget.html");
    var html = tmpl.render(context);
    this.$el.html(html);
  },

  clickAddBtn: function(e) {
    e.preventDefault();
    var view = this;

    openFormModal(
      {
        url: this.foreignKeyView.createUrl,
        data: view.formDefaultsAjaxData
      },
      function(response) {
        var response;
        view.foreignKeyView.modelDataChanged(response);
      },
      function() {
        view.modalOpenedCallback();
      }
    );
  },

  clickEditBtn: function(e) {
    //TODO: make Edit and Add DRY

    e.preventDefault();
    var view = this;
    var updateUrl = this.model.get("cms_update_url");

    console.log("clicked edit button for FK");

    openFormModal(
      { url: updateUrl },
      function(response) {
        var imageAssetData = response;
        view.model.set(imageAssetData);
      },
      function() {
        initializePluginsAndWidgets();
        console.log("initiializePluginsAndWIdgets from popup");
        view.modalOpenedCallback();
      }
    );
  },

  clickCropImageBtn: function(context, e, cropKey) {
    e.preventDefault();
  },

  clickRemoveBtn: function(e) {
    e.preventDefault();
    var view = this;
    if (view.options.removeElementOnRemove) {
      view.model.destroyLocalOnly();
    }
  },

  drop: function() {}, //must override to implement

  startDragging: function() {}, //override to implement

  stopDragging: function() {
    this.$el.find("[js-drop-area]").removeClass("wrong-type");
  },

  modalOpenedCallback: function() {
    //override to implement
    $("[js-tabbed-fieldsets]").tabbedFieldsets();
    $("[js-image-input-widget]").each(function(i, el) {
      new ImageAssetInputWidgetView({ el: el });
    });
  }
});

var ForeignKeyWidgetView = BaseView.extend({
  //TODO: abstract out the stuff inside //IMAGE comments

  defaultOptions: {
    showAddBtn: true,
    showEditBtn: true,
    showRemoveBtn: true,
    removeElementOnRemove: true
  },

  modelClass: BaseModel,

  enhancementViewClass: ForeignKeyWidgetEnhancementView,

  initialize: function(options) {
    var view = this;

    view.options = Object.assign({}, view.defaultOptions, options);

    var $el = view.$el;
    view.$inputElement = $el.find(".native-widget").find("select, input"); //can be either a <select> or an <input> element
    view.$inputElementTag = view.$inputElement.prop("tagName").toLowerCase();

    // form default values:
    view.formDefaults = {};
    _.each($el.data(), function(value, key) {
      if (key.indexOf("default") == 0) {
        var fieldName = key.toLowerCase().replace("default", "");
        view.formDefaults[fieldName] = value;
      }
    });

    view.formDefaultsAjaxData = {};
    _.each(view.formDefaults, function(value, key) {
      view.formDefaultsAjaxData["form-" + key] = value;
    });

    this.createUrl = $el.data("create-url");
    var modelId = view.$inputElement.val();
    if (modelId.trim() == "") {
      modelId = null;
    }
    if (!modelId) {
      view.model = null;
      view.render();
    } else {
      this.createInitialModel(modelId, function(model) {
        view.model = model;

        // ALL these need to be rebinded when the model is swapped!
        view.enhancementView = null;
        view.rebindModelEvents();
        view.render();
      });
    }
  },

  rebindModelEvents: function() {
    var view = this;
    view.listenTo(view.model, "destroy", function() {
      view.modelRemoved();
    });
    view.listenTo(view.model, "change", function() {
      if (view.$inputElementTag == "select") {
        var $option = view.$inputElement.find(":selected");
        $option.text(view.model.get("unicode"));
        view.$inputElement.trigger("liszt:updated");
      }
    });
  },

  createInitialModel: function(modelId, callback) {
    var view = this;
    var initData = {
      id: modelId,
      cms_update_url: view.$el.data("update-url")
    };
    callback(new view.modelClass(initData));
  },

  modelRemoved: function() {
    this.model = null;
    var view = this;
    this.render();
  },

  fetchModelById: function(id, success) {
    var view = this;
    var model = new view.modelClass({ id: id });
    model.fetch({
      success: function() {
        success(model);
      }
    });
  },

  modelIdChanged: function(id) {
    var view = this;
    view.model = new view.modelClass({ id: id });
    view.model.fetch({
      success: function() {
        view.modelChanged(view.model);
      }
    });
  },

  modelDataChanged: function(data) {
    var view = this;
    var modelData = data;
    view.model = new view.modelClass(modelData);
    view.modelChanged(view.model);
  },

  modelChanged: function(model) {
    var view = this;
    if (view.$inputElementTag == "select") {
      view.$inputElement.append(
        $("<option></option>")
          .attr("value", view.model.id)
          .text(view.model.get("unicode"))
      );
      view.$inputElement.val(view.model.id);
      view.$inputElement.trigger("liszt:updated"); //TODO: i think the latest plugin uses chose:updated rather than liszt:updated
    } else {
      view.$inputElement.val(view.model.id);
    }
    view.rebindModelEvents();
    view.render();
  },

  render: function() {
    var view = this;
    if (view.$inputElementTag == "select") {
      this.$inputElement.chosen();
    }
    this.renderNativeWidget();
    this.renderEnhancementView();
  },

  renderNativeWidget: function() {
    if (this.model == null) {
      this.$inputElement.val(""); //this should be part of render ??
      if (this.$inputElementTag == "select") {
        this.$inputElement.trigger("liszt:updated"); //TODO: i think the latest plugin uses chose:updated rather than liszt:updated
      }
    }
  },

  removeExistingEnhancementView: function() {
    if (this.enhancementView != null) {
      this.enhancementView.remove(); //recreate the enhancement view everytime the foreign key is changed!
    }
  },

  renderEnhancementView: function() {
    var view = this;
    view.removeExistingEnhancementView();

    var enhancementViewClass = this.enhancementViewClass;

    this.enhancementView = new enhancementViewClass({
      className: "enhanced-widget",
      foreignKeyView: view,
      model: view.model
    });
    view.$el.find(".enhanced-widget").remove();
    view.enhancementView.$el.appendTo(view.$el);
  }
});

var ImageAssetWidgetEnhancementView = ForeignKeyWidgetEnhancementView.extend({
  render: function() {
    var options = this.foreignKeyView.options;
    var context = {
      showEditBtn: options.showEditBtn,
      showAddBtn: options.showAddBtn,
      showRemoveBtn: options.showRemoveBtn,
      cropButtons: {}
    };

    var cropKeys = getCropKeys();
    for (let cropKey of cropKeys) {
      var data = initial_data.main_image_crop_data[cropKey];
      data.cropped = data.crop != null;
      context.cropButtons[getCropButtonSlug(cropKey)] = data;
    }

    if (this.model == null) {
      context.model = null;
    } else {
      var modelData = this.model.toJSON();
      context.model = modelData;
      context.imageUrl = modelData[options.imageUrlParam];
    }

    var tmpl = require("../nunjucks-templates/widgets/image-asset-widget.html");
    var html = tmpl.render(context);
    this.$el.html(html);
  },

  drop: function(e, data) {
    var view = this;
    var assetId = data.assetId;
    var assetType = data.assetType;
    switch (assetType) {
      case "image":
        view.foreignKeyView.modelIdChanged(data.assetId);
        break;
      default:
        break;
    }
  },

  clickCropImageBtn: function(context, e, cropKey) {
    e.preventDefault();
    context.openAoiModal(cropKey);
  },

  openAoiModal: function(cropKey) {
    console.log("cropKey", cropKey);
    var title, aspectRatio;
    var type = "CROP";
    title = "CROP";
    var view = this;

    var cropSettings = initial_data.main_image_crop_data[cropKey];
    console.log("cropSettings", cropSettings);

    var cropperView = null;

    aspectRatio = cropSettings.aspect_ratio;

    var options = {
      imageUrl: view.model.get("cms_normal_url"),
      aspectRatio: aspectRatio,
      onreadyCallback: function() {
        cropperView.$el.ensoModal("open", function() {
          cropperView.initJcrop();
        });
      },
      submitCallback: function() {
        var urlTail;
        var data = {
          coords: cropperView.getNormalisedCoords(),
          cropKey: cropKey
        };

        start_fullscreen_spinner();
        urlTail = type.toLowerCase();

        $.ajax({
          url: "/api/core/imageassets/" + view.model.id + "/" + urlTail,
          data: JSON.stringify(data),
          type: "PATCH",
          processData: false,
          contentType: "application/json" //typically 'application/x-www-form-urlencoded', but the service you are calling may expect 'text/json'... check with the service to see what they expect as content-type in the HTTP header.
        }).done(function(response) {
          cropperView.$el.ensoModal("destroy");
          stop_fullscreen_spinner();
        });
      }
    };

    options.title = title;
    if (
      this.foreignKeyView.cropWidthOverride &&
      this.foreignKeyView.cropHeightOverride
    ) {
      options.cropWidth = this.foreignKeyView.cropWidthOverride;
      options.cropHeight = this.foreignKeyView.cropHeightOverride;
    }
    cropperView = new ImageCropperView(options);
  },

  startDragging: function(data) {
    var assetType = data.assetType;
    switch (assetType) {
      case "image":
        break;
      default:
        this.$el.find("[js-drop-area]").addClass("wrong-type");
    }
  }
});

var ImageAssetWidgetView = ForeignKeyWidgetView.extend({
  modelClass: ImageAssetModel,

  enhancementViewClass: ImageAssetWidgetEnhancementView,

  initialize: function(options) {
    var defaults = {
      imageUrlParam: "cms_thumbnail_url"
    };

    options = Object.assign({}, defaults, options);

    ForeignKeyWidgetView.prototype.initialize.call(this, options);
  },

  createInitialModel: function(modelId, callback) {
    var view = this;
    view.fetchModelById(modelId, function(model) {
      callback(model);
    });
  },

  render: function() {
    this.$inputElement.hide();
    this.renderNativeWidget();
    this.renderEnhancementView();
  }
});

var GalleryEditView = BaseView.extend({
  initialize: function() {
    var view = this;
    view.imageWidgets = [];
    view.blankImageWidget = null;

    view.$el
      .find(".update-entries [js-image-gallery-image-widget]")
      .each(function(i, el) {
        view.imageWidgets.push(
          new GalleryImageAssetWidgetView({
            el: el,
            gallery: view,
            isBlank: false
          })
        );
      });
    view.$el
      .find(".new-entries [js-image-gallery-image-widget]")
      .each(function(i, el) {
        view.blankImageWidget = new GalleryImageAssetWidgetView({
          el: el,
          gallery: view,
          isBlank: true
        });
      });
  },

  createNewBlankEntry: function() {
    var view = this;

    /**
     * copied from contrib/admin/static/admin/js/inlines.js
     */
    var updateElementIndex = function(el, prefix, ndx) {
      var id_regex = new RegExp("(" + prefix + "-(\\d+|__prefix__))");
      var replacement = prefix + "-" + ndx;
      if ($(el).attr("for")) {
        $(el).attr(
          "for",
          $(el)
            .attr("for")
            .replace(id_regex, replacement)
        );
      }
      if (el.id) {
        el.id = el.id.replace(id_regex, replacement);
      }
      if (el.name) {
        el.name = el.name.replace(id_regex, replacement);
      }
    };

    var prefix = "galleryimages_set";
    var totalFormsInput = $("#id_" + prefix + "-TOTAL_FORMS");
    var totalForms = parseInt(totalFormsInput.val());

    var $newEntriesSection = $(".image-gallery-edit .new-entries");
    var $newBlankEntry = view.blankImageWidget.$el.clone(false);
    $newBlankEntry.appendTo($newEntriesSection);

    $newBlankEntry.find("*").each(function() {
      updateElementIndex(this, prefix, totalForms);
    });
    new GalleryImageAssetWidgetView({
      el: $newBlankEntry.get(0),
      gallery: view,
      isBlank: true
    });
    $(totalFormsInput).val(parseInt(totalFormsInput.val()) + 1);
  }
});

var GalleryImageAssetWidgetView = BaseView.extend({
  initialize: function(options) {
    var view = this;
    view.gallery = options.gallery;
    view.isBlank = options.isBlank;

    view.innerWidget = new GalleryInnerImageAssetWidget({
      el: $(view.el).find("[js-gallery-inner-image-asset-widget]")[0]
    });
  },

  events: {
    "click [js-remove-foreign-key-btn]": "clickRemoveBtn",
    "enso:drop [js-drop-area]": "drop"
  },

  clickRemoveBtn: function(e) {
    e.preventDefault();
    this.$el.find("input[name$='DELETE']").prop("checked", true);
    this.$el.hide(200);
  },

  drop: function(e, data) {
    var view = this;
    if (view.isBlank) {
      view.gallery.createNewBlankEntry();
      view.isBlank = false;
    }
  }
});

var GalleryInnerImageAssetWidget = ImageAssetWidgetView.extend({
  defaultOptions: $.extend({}, ImageAssetWidgetView.prototype.defaultOptions, {
    removeElementOnRemove: false
  })
});

var MainImageAssetWidgetView = ImageAssetWidgetView.extend({
  defaultOptions: $.extend({}, ImageAssetWidgetView.prototype.defaultOptions, {
    imageUrlParam: "cms_normal_url"
  }),

  createInitialModel: function(modelId, callback) {
    callback(this.model); //it's already been passed on iti
  }
});

var MediaAssetWidgetEnhancementView = ForeignKeyWidgetEnhancementView.extend({
  render: function() {
    var options = this.foreignKeyView.options;
    var context = {
      showEditBtn: options.showEditBtn,
      showAddBtn: options.showAddBtn,
      showRemoveBtn: options.showRemoveBtn
    };

    if (this.model == null) {
      context.model = null;
    } else {
      var modelData = this.model.toJSON();
      context.model = modelData;
      context.imageUrl = modelData[options.imageUrlParam];
    }

    var tmpl = require("../nunjucks-templates/widgets/media-asset-widget.html");
    var html = tmpl.render(context);
    this.$el.html(html);
  },

  drop: function(e, data) {
    var view = this;
    var assetId = data.assetId;
    var assetType = data.assetType;
    switch (assetType) {
      case "audio":
      case "video":
        view.foreignKeyView.modelIdChanged(data.assetId);
        break;
      default:
        break;
    }
  },

  startDragging: function(data) {
    var assetType = data.assetType;
    switch (assetType) {
      case "audio":
      case "video":
        break;
      default:
        this.$el.find("[js-drop-area]").addClass("wrong-type");
    }
  }
});

var MediaAssetWidgetView = ForeignKeyWidgetView.extend({
  modelClass: AssetModel,

  enhancementViewClass: MediaAssetWidgetEnhancementView,

  defaultOptions: $.extend({}, ForeignKeyWidgetView.prototype.defaultOptions, {
    showAddBtn: false,
    showEditBtn: true,
    showRemoveBtn: true
  }),

  createInitialModel: function(modelId, callback) {
    var view = this;
    view.fetchModelById(modelId, function(model) {
      callback(model);
    });
  },

  render: function() {
    this.$inputElement.hide();
    this.renderNativeWidget();
    this.renderEnhancementView();
  }
});

/*******************************************************************************
 * Asset Manager Panel
 ******************************************************************************/

var AssetManagerPanelViewModel = BaseModel.extend({
  defaults: {
    ap_object_id: initial_data.ap_object_pk,
    query: "",
    show_related: false,
    page: 1,
    loading: false
  },

  showRelated: function(force_update) {
    var force_update =
      typeof force_update === "undefined" ? false : force_update;
    this.clear();

    if (force_update) {
      this.trigger("refresh"); //trigger change event even though nothing has changed
    } else {
      this.set({
        show_related: true,
        page: 1,
        query: ""
      });
    }
  },

  showAll: function() {
    this.clear();
    this.set({
      show_related: false,
      page: 1,
      query: ""
    });
  },

  submitQuery: function(query) {
    this.clear();
    this.set({
      page: 1,
      show_related: false,
      query: query
    });
  },

  getNextPage: function() {
    this.set({
      page: this.get("page") + 1
    });
  },

  clear: function() {
    this.trigger("clear-collection");
  }
});

/**
 * this is essentially a "controller" to coordinate the parts of the asset panel
 * A "ViewModel" is used to store frontend UI state data (as opposed to backend asset data)
 */
var AssetManagerPanelView = BaseView.extend({
  initialize: function() {
    var view = this;
    var htmlSettings = view.$el.data(); //settings defined in html using data- attributes
    view.ap_object_id =
      htmlSettings.relatedApObjectId !== "undefined"
        ? htmlSettings.relatedApObjectId
        : null;
    view.viewModel = new AssetManagerPanelViewModel({
      ap_object_id: view.ap_object_id,
      show_related: view.ap_object_id != null
    });
    view.render();

    view.listenTo(view.viewModel, "refresh", function() {
      view.refresh();
    });

    view.listenTo(view.viewModel, "change", function() {
      var changedAttributes = view.viewModel.changedAttributes();

      view.bottomView.render();

      var queryChanged = _.has(changedAttributes, "query");
      var showRelatedChanged = _.has(changedAttributes, "show_related");
      var pageChanged = _.has(changedAttributes, "page");

      if (showRelatedChanged || queryChanged || pageChanged) {
        view.refresh();
      }
    });

    view.listenTo(view.viewModel, "clear-collection", function() {
      view.assetListView.clear();
    });

    view.listenTo(view.viewModel, "change:loading", function(__, loading) {
      if (loading) {
        view.$spinnerContainer.show();
      } else {
        view.$spinnerContainer.hide();
      }
    });

    view.refresh();
  },

  refresh: function() {
    var view = this;

    var data = {
      page: view.viewModel.get("page")
    };

    if (view.viewModel.get("show_related") == true) {
      data.ap_object_id = view.viewModel.get("ap_object_id");
    }
    var query = view.viewModel.get("query");
    if (query) {
      data.q = query;
    }

    view.viewModel.set("loading", true);
    view.collection.fetch({
      data: data,
      success: function() {
        view.viewModel.set("loading", false);
        view.assetListView.render();
      },
      error: function() {
        // trying to get a next page that doesn't exist throws a 404, so let's at
        // least stop the spinner!
        view.viewModel.set("loading", false);
      }
    });
  },

  render: function() {
    var view = this;

    view.collection = new AssetCollection([], {
      viewModel: view.viewModel
    });

    var tmpl = require("../nunjucks-templates/asset-manager-panel/panel.html");
    var html = tmpl.render({});
    view.$el.html(html);

    view.topView = new AssetManagerPanelTopView({
      el: view.$("[js-asset-manager-panel-top]"),
      viewModel: view.viewModel,
      panelView: view
    });

    view.assetListView = new AssetManagerPanelListView({
      el: view.$("[js-asset-list]"),
      viewModel: view.viewModel,
      collection: view.collection,
      panelView: view
    });

    view.bottomView = new AssetManagerPanelBottomView({
      el: view.$("[js-asset-manager-panel-bottom]"),
      viewModel: view.viewModel,
      collection: view.collection,
      panelView: view
    });

    // put a spinner in
    view.$spinnerContainer = $(".asset-panel-spinner");
    view.$("[js-asset-panel-spinner]").spin({
      lines: 11, // The number of lines to draw
      length: 2, // The length of each line
      width: 2, // The line thickness
      radius: 5, // The radius of the inner circle
      corners: 1, // Corner roundness (0..1)
      rotate: 0, // The rotation offset
      direction: 1, // 1: clockwise, -1: counterclockwise
      color: "#000", // #rgb or #rrggbb or array of colors
      speed: 1, // Rounds per second
      trail: 60, // Afterglow percentage
      shadow: false, // Whether to render a shadow
      hwaccel: false, // Whether to use hardware acceleration
      className: "spinner", // The CSS class to assign to the spinner
      zIndex: 2e9 // The z-index (defaults to 2000000000)
      //                top: '50%', // Top position relative to parent
      //                left: '50%' // Left position relative to parent
    });
  }
});

var AssetManagerPanelTopView = BaseView.extend({
  initialize: function(options) {
    var view = this;
    view.viewModel = options.viewModel;
    view.panelView = options.panelView;
    view.$assetSearchForm = $("#asset-search-form");
    view.$assetSearchQ = $("#asset-search-q");
    view.render();

    view.listenTo(view.viewModel, "change", function() {
      view.render();
    });
  },

  events: {
    "submit #asset-search-form": "submitAssetSearchForm"
  },

  render: function() {
    var view = this;
    var context = view.viewModel.toJSON();
    var tmpl = require("../nunjucks-templates/asset-manager-panel/top.html");
    var html = tmpl.render(context);
    view.$el.html(html);
  },

  submitAssetSearchForm: function(e) {
    e.preventDefault();
    var view = this;
    var query = $("#asset-search-q").val();
    view.viewModel.submitQuery(query);
  }
});

var AssetManagerPanelBottomView = BaseView.extend({
  initialize: function(options) {
    var view = this;
    view.viewModel = options.viewModel;
    view.panelView = options.panelView;
    view.render();
    view.$showRelatedAssetsBtn = view.$("[js-show-related-assets]");
    view.$showAllAssetsBtn = view.$("[js-show-all-assets]");
    view.$fileInput = $("#asset-library-multi-file-input");
  },

  events: {
    "click [js-asset-library-add-btn]": "clickAddAssetButton",
    "click [js-show-all-assets]": "clickShowAllAssetsButton",
    "click [js-show-related-assets]": "clickShowRelatedAssetsButton"
  },

  render: function() {
    var view = this;
    var tmpl = require("../nunjucks-templates/asset-manager-panel/bottom.html");
    var html = tmpl.render(view.viewModel.toJSON());
    view.$el.html(html);
  },

  clickShowAllAssetsButton: function(e) {
    e.preventDefault();
    var view = this;
    view.viewModel.showAll();
  },

  clickShowRelatedAssetsButton: function(e) {
    e.preventDefault();
    var view = this;
    view.viewModel.showRelated();
  },

  clickAddAssetButton: function(e) {
    var view = this;
    e.preventDefault();

    var MAX_FILENAME_LENGTH = 64; //a total of 64 UTF8 4 byte characters are possible on linux ext3

    var url = initial_data.asset_create_multiple_url;

    view.$fileInput.trigger("click");

    view.$fileInput.on("change", function() {
      var fileInput = view.$fileInput[0];
      //TODO: if html5 FileApi is not supported, then assume only one file could be uploaded at a time

      var files = fileInput.files;
      var fileUploadsLeft = files.length;

      var fileData = []; //to be sent to the server to generate forms
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        console.log("file type", file.type);
        if (file.name.length > MAX_FILENAME_LENGTH) {
          alert(
            "Unfortunately the file " +
              file.name +
              " cannot be uploaded as it is " +
              file.name.length +
              " characters long. The file name must be less than " +
              MAX_FILENAME_LENGTH +
              " characters long."
          );
        } else if (!_.contains(ALLOWED_FILE_TYPES, file.type)) {
          alert(
            "Unfortunately the file " +
              file.name +
              " cannot be uploaded as the type " +
              file.type +
              " is not supported"
          );
        } else {
          fileData.push({
            js_id: i,
            name: file.name,
            size: file.size,
            type: file.type
          });
        }
      }

      if (fileData.length > 0) {
        $.ajax({
          type: "POST",
          url: url,
          data: {
            data: JSON.stringify(fileData),
            method: "GET"
          }
        }).done(function(response) {
          var $assetsWrapper = $(response);
          var $saveAssetsBtn = $assetsWrapper.find("#save-assets-btn");
          $saveAssetsBtn.addClass("disabled");

          $assetsWrapper.ensoModal(); //open the modal

          var $assetMetaDataForms = $assetsWrapper.find(
            "form.asset-metadata-form"
          );
          $assetMetaDataForms.each(function(i, e) {
            var $form = $(e);
            $form.on("submit", function(e) {
              e.preventDefault();
            });
          });

          var fileUploadUrl = $assetsWrapper.data("file-upload-url");
          var createAssetsUrl = $assetsWrapper.data(
            "asset-create-multiple-url"
          );

          var $uploadWidgets = $assetsWrapper.find("[js-asset-upload]");

          // now that we have server side generated uuid's for the files, we can upload them
          //TODO: don't just upload them all at once, do a maximum of 3 or so at a time
          $uploadWidgets.each(function(i, e) {
            var $uploadWidget = $(e);
            var $progressBar = $uploadWidget.find(
              "[js-progress] .progress-bar"
            );
            var uuid = $uploadWidget.data("uuid");

            // upload the file asynchronously wile the user fills out the rest of the form
            var fileUploadFormData = new FormData(
              $uploadWidget.find("form.file-upload-form")[0]
            );
            var file = files[parseInt($uploadWidget.data("js-id"))];
            var mimeType = getMimeObject(file.type);
            fileUploadFormData.append("file", file);

            var xhr = new window.XMLHttpRequest();
            xhr.open("POST", fileUploadUrl);
            xhr.onload = function(event) {
              fileUploadsLeft--;
              if (fileUploadsLeft == 0) {
                $saveAssetsBtn.removeClass("disabled");
              }
            };

            xhr.upload.onprogress = function(event) {
              if (!event.lengthComputable) {
                return; //TODO: in this case we should turn the progress meter into a 'spinner' type view
              }
              // Update file size because it might be bigger than reported by the fileSize:
              var percentComplete = event.loaded / event.total * 100.0;
              $progressBar.css("width", percentComplete + "%");
            };

            setTimeout(function() {
              xhr.send(fileUploadFormData);
            }, 500);

            // show a preview of the file using html5 FileReader

            var fileReader = new FileReader();

            fileReader.onload = function(e) {
              uri = e.target.result;
              switch (mimeType.mediaType) {
                case "image":
                  var $previewImage = $uploadWidget.find("[js-image-preview]");
                  $previewImage.attr("src", uri);
                  break;
                case "audio":
                  var $previewAudio = $uploadWidget.find("[js-audio-preview]");
                  var uri = e.target.result;
                  //$previewAudio.find('source')[0].src = uri;
                  //$previewAudio[0].load();
                  break;
                case "video":
                  var $previewVideo = $uploadWidget.find("[js-video-preview]");
                  var uri = e.target.result;
                  //$previewVideo.find('source')[0].src = uri;
                  //$previewVideo[0].load();
                  break;
              }
            };
            fileReader.readAsDataURL(file);

            // seeing as the page has multiple of the same form and it's
            // a hassle to have to namespace each field by appending a number (title-1, title-2, etc)
            // we are going to serialise each form as a JSON structure where the key to each object
            // is the uuid for the file. This will be posted as a single querystring parameter 'data'
          });

          $saveAssetsBtn.on("click", function(e) {
            // don't let the user save until all files have been uploaded
            if (!$(this).hasClass(".disabled")) {
              start_fullscreen_spinner();
              e.preventDefault();

              var allFormData = {};

              $uploadWidgets.each(function() {
                var $widget = $(this);
                var $form = $widget.find(".asset-metadata-form");
              });

              $assetsWrapper.find(".asset-metadata-form").each(function() {
                var $form = $(this);
                var formData = $form.serializeObject();
                formData.related_ap_object_pk = initial_data.ap_object_pk;
                allFormData[formData.uuid] = formData;
              });

              $.ajax({
                type: "POST",
                url: createAssetsUrl,
                data: {
                  data: JSON.stringify(allFormData),
                  method: "POST"
                }
              }).done(function(response) {
                $assetsWrapper.ensoModal("destroy");
                view.relatedOnly = true;
                view.viewModel.showRelated(true);
                stop_fullscreen_spinner();
              });
            }
          });
        });
      }
    });
  }
});

//TODO: we really need a collection, and all the necessary endpoints

var AssetManagerPanelListView = BaseView.extend({
  initialize: function(options) {
    var view = this;
    view.viewModel = options.viewModel;
    view.assetItemViews = [];
    view.collection = options.collection;

    //TODO: this assumes we are using this from an ap object page.
    // perhaps pass as an initialization argument?
  },

  events: {
    scroll: "scrollAssetList"
  },

  render: function() {
    var view = this;
    view.collection.each(function(asset) {
      view.appendAssetView(asset);
    });
  },

  clear: function() {
    this.$el.empty();
  },

  appendAssetView: function(asset) {
    var view = this;
    var assetView = new AssetManagerPanelItemView({
      model: asset
    });
    view.assetItemViews.push(assetView);
    assetView.$el.appendTo(view.$el);
  },

  //TODO!
  scrollAssetList: function() {
    var view = this;
    var $list = $(this);
    if (view.$el.scrollTop() + view.$el.innerHeight() >= view.el.scrollHeight) {
      view.viewModel.getNextPage();
    }
  }
});

var AssetManagerPanelItemView = BaseView.extend({
  tagName: "li",
  className: "draggable",

  initialize: function() {
    var view = this;
    view.render();
  },

  render: function() {
    var tmpl = require("../nunjucks-templates/asset-manager-panel/item.html");
    var html = tmpl.render({ asset: this.model.toJSON() });
    this.$el.html(html);
  },

  events: {
    mousedown: "clickDraggableAsset",
    "click     [js-edit-foreign-key-btn]": "clickEditForeignKeyButton"
  },

  clickDraggableAsset: function(e) {
    var view = this;
    e.preventDefault();
    var assetId = this.model.get("id");
    var assetType = this.model.get("media_type_slug");

    globalEvents.trigger("enso:startDragging", {
      $draggable: view.$el,
      assetId: assetId,
      assetType: assetType
    });
  },

  clickEditForeignKeyButton: function(e) {
    e.stopPropagation();
    e.preventDefault();

    var view = this;
    var updateUrl =
      "/" +
      view.model.get("media_type_slug") +
      "-asset/" +
      view.model.id +
      "/update/";

    openFormModal(
      { url: updateUrl },
      function(response) {
        //var imageAssetData = response;
        //view.model.set(imageAssetData);
      },
      function($modal) {
        $("[js-tabbed-fieldsets]").tabbedFieldsets();
        $("[js-image-input-widget]").each(function(i, el) {
          new ImageAssetInputWidgetView({ el: el });
        });
        initializePluginsAndWidgets();

        var $deleteButton = $("[js-delete-button]");
        $deleteButton.on("click", function(e) {
          console.log("click");
          e.preventDefault();
          var id = $deleteButton.data("object-id");
          $.get("/api/core/imageassets/" + id + "/related-objects", function(
            data
          ) {
            var canDelete = false;
            var message = "";
            if ($.isEmptyObject(data.related_objects)) {
              canDelete = true;
              message += "\n Are you sure you want to delete this asset?";
            } else {
              message =
                "This asset can not be deleted as it is being used by the following items:\n\n";
              $.each(data.related_objects, function(type, items) {
                console.log(type);
                message += type + "\n";
                $.each(items, function(i, item) {
                  message += item + "\n";
                });
              });
              message +=
                "\n\nThe asset must be detached from these items by clicking the [x] button on the asset for the item, and then saving the item.";
            }
            if (canDelete) {
              confirmed = confirm(message);
              if (confirmed) {
                $.ajax({
                  url: "/api/core/imageassets/" + id + "/delete",
                  type: "DELETE",
                  success: function(result) {
                    location.reload();
                  }
                });
              }
            } else {
              alert(message);
            }
          });
        });
      }
    );
  }
});

var CurrentlyDraggingObjectView = BaseView.extend({
  initialize: function(options) {
    this.options = options;
    //do render here:
    var $draggable = this.options.$draggable;

    var $fromImg = $draggable.find("img");
    var origWidth = $fromImg[0].clientWidth;
    var origHeight = $fromImg[0].clientHeight;
    var ENLARGE_MULTIPLIER = 1.5;
    var spriteWidth = origWidth * ENLARGE_MULTIPLIER;
    var spriteHeight = origHeight * ENLARGE_MULTIPLIER;

    var src = $fromImg.attr("src");
    var $spriteImage = $('<img src="' + src + '" />');
    $spriteImage.css({
      position: "relative",
      top: -(spriteHeight / 2),
      left: -(spriteWidth / 2),
      width: spriteWidth,
      height: spriteHeight,
      border: "2px solid white"
    });

    var $sprite = $("<div>");
    $spriteImage.appendTo($sprite);
    $sprite.css({
      "pointer-events": "none", // This is a very important css property which means that the underlying element can still recieve mouse events. Does not work in IE10!
      position: "absolute",
      "z-index": "1000",
      left: bodyView.currX - origWidth / 2,
      top: bodyView.currY - origHeight / 2
    });
    $sprite.appendTo("body");
    this.$el = $sprite;
  },

  setPos: function(left, top) {
    this.$el.css({
      left: left,
      top: top
    });
  }
});

var MultipleAssetsView = BaseView.extend({
  initialize: function() {
    var view = this;

    this.$selectElement = this.$("select");
    this.$selectElement.addClass("hidden");
    this.$el
      .closest("field")
      .find(".helptext")
      .hide();
    this.$fileInput = $('<input type="file" multiple />');
    var $fileInput = this.$fileInput;
    $fileInput.appendTo(this.$el);

    this.$expectedFilenamesInput = $("#id_filenames");
    this.expectedFilenames = _.map(
      this.$expectedFilenamesInput.text().split("\n"),
      function(filename) {
        return filename.trim();
      }
    );

    this.fetchAssetData();

    $fileInput.on("change", function() {
      startMainLoading();
      //TODO: if html5 FileApi is not supported, then assume only one file could be uploaded at a time

      var files = this.files;

      var fileData = []; //to be sent to the server to generate forms
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        fileData.push({
          js_id: i,
          name: file.name,
          size: file.size,
          type: file.type
        });
      }
      var filenames = _.map(fileData, function(file) {
        return file.name;
      });
      var fileCheck = view.checkFiles(filenames);
      var filesToUpload = [];
      _.each(fileData, function(file) {
        if (_.contains(fileCheck.correctFiles, stripExtension(file.name))) {
          filesToUpload.push(file);
        }
      });

      var fileUploadsLeft = filesToUpload.length;

      const template = require("../nunjucks-templates/device-files-confirm.html");
      var $confirmBox = $(template.render(fileCheck));
      $confirmBox.find(".cancel-button").on("click", function() {
        $confirmBox.ensoModal("destroy");
      });
      $confirmBox.find(".ok-button").on("click", function() {
        $confirmBox.ensoModal("destroy");

        var createAssetsUrl = "/asset/create-update-multiple/";
        $.ajax({
          type: "POST", // semantically it should be GET, but the payload is often too large for nginx/UWSGI to handle
          url: createAssetsUrl,
          data: {
            "file-data": JSON.stringify(filesToUpload),
            type: "GET"
          } //encode json as a querystring parameter
        }).done(function(response) {
          var $assetsWrapper = $(response);
          var $saveAssetsBtn = $assetsWrapper.find("#save-assets-btn");
          $saveAssetsBtn.addClass("disabled");
          $assetsWrapper.ensoModal(); //open the modal
          var fileUploadUrl = $assetsWrapper.data("file-upload-url");
          var createAssetsUrl = $assetsWrapper.data(
            "asset-create-multiple-url"
          );

          var $uploadWidgets = $assetsWrapper.find("[js-asset-upload]");

          // now that we have server side generated uuid's for the files, we can upload them
          //TODO: don't just upload them all at once, do a maximum of 3 or so at a time
          $uploadWidgets.each(function(i, e) {
            var $uploadWidget = $(e);
            var $progressBar = $uploadWidget.find(
              "[js-progress] .progress-bar"
            );
            var uuid = $uploadWidget.data("uuid");

            // upload the file asynchronously wile the user fills out the rest of the form
            var fileUploadFormData = new FormData(
              $uploadWidget.find("form.file-upload-form")[0]
            );
            var file = files[parseInt($uploadWidget.data("js-id"))];
            var mimeType = getMimeObject(file.type);
            fileUploadFormData.append("file", file);

            var xhr = new window.XMLHttpRequest();
            xhr.open("POST", fileUploadUrl);
            xhr.onload = function(event) {
              fileUploadsLeft--;
              if (fileUploadsLeft == 0) {
                $saveAssetsBtn.removeClass("disabled");
              }
            };

            xhr.upload.onprogress = function(event) {
              if (!event.lengthComputable) {
                return; //TODO: in this case we should turn the progress meter into a 'spinner' type view
              }
              // Update file size because it might be bigger than reported by the fileSize:
              var percentComplete = event.loaded / event.total * 100.0;
              $progressBar.css("width", percentComplete + "%");
            };

            setTimeout(function() {
              xhr.send(fileUploadFormData);
            }, 500);

            // show a preview of the file using html5 FileReader

            var fileReader = new FileReader();

            fileReader.onload = function(e) {
              uri = e.target.result;
              switch (mimeType.mediaType) {
                case "image":
                  var $previewImage = $uploadWidget.find("[js-image-preview]");
                  $previewImage.attr("src", uri);
                  break;
                case "audio":
                  var $previewAudio = $uploadWidget.find("[js-audio-preview]");
                  var uri = e.target.result;
                  //$previewAudio.find('source')[0].src = uri;
                  //$previewAudio[0].load();
                  break;
                case "video":
                  var $previewVideo = $uploadWidget.find("[js-video-preview]");
                  var uri = e.target.result;
                  //$previewVideo.find('source')[0].src = uri;
                  //$previewVideo[0].load(); //disabled as it kills the
                  break;
              }
            };
            fileReader.readAsDataURL(file);

            // seeing as the page has multiple of the same form and it's
            // a hassle to have to namespace each field by appending a number (title-1, title-2, etc)
            // we are going to serialise each form as a JSON structure where the key to each object
            // is the uuid for the file. This will be posted as a single querystring parameter 'data'
          });

          $saveAssetsBtn.on("click", function(e) {
            // don't let the user save until all files have been uploaded
            if (!$(this).hasClass(".disabled")) {
              startMainLoading();
              e.preventDefault();

              var allFormData = {};

              $uploadWidgets.each(function() {
                var $widget = $(this);
                var $form = $widget.find(".asset-metadata-form");
              });

              $assetsWrapper.find(".asset-metadata-form").each(function() {
                var $form = $(this);
                var formData = $form.serializeObject();
                formData.related_ap_object_pk = initial_data.ap_object_pk;
                allFormData[formData.uuid] = formData;
              });

              $.ajax({
                type: "POST",
                url: createAssetsUrl,
                data: { data: JSON.stringify(allFormData) }
              }).done(function(response) {
                $assetsWrapper.ensoModal("destroy");

                var uploadedAssets = response.assets;
                var uploadedFilenames = [];
                _.each(uploadedAssets, function(asset) {
                  uploadedFilenames.push(
                    stripExtension(asset.original_filename)
                  );
                });
                var uploadedAssetIds = [];
                _.each(uploadedAssets, function(asset) {
                  uploadedAssetIds.push(asset.id);
                });

                var newAssetIds = _.difference(
                  uploadedAssetIds,
                  view.currUploadedAssetIds
                );
                // add option elements for these, we don't really care what the label is as it won't be seen
                _.each(newAssetIds, function(id) {
                  view.$selectElement.append(
                    '<option value="' + id + '">' + id + "</option>"
                  );
                });
                view.currUploadedAssetIds = _.union(
                  view.currUploadedAssetIds,
                  uploadedAssetIds
                );
                view.$selectElement.val(view.currUploadedAssetIds);
                stopMainLoading();
              });
            }
          });
        });
      });

      $confirmBox.ensoModal();
      stopMainLoading();
    });
  },

  checkFiles: function(filenames) {
    filenames = _.map(filenames, function(f) {
      return stripExtension(f);
    });

    var notExpected = _.difference(filenames, this.expectedFilenames);
    var notSupplied = _.difference(this.expectedFilenames, filenames);
    var correctFiles = _.intersection(this.expectedFilenames, filenames);

    return {
      notExpected: notExpected,
      notSupplied: notSupplied,
      correctFiles: correctFiles,
      toBeReplaced: _.intersection(correctFiles, this.currUploadedFilenames),
      toBeCreated: _.difference(correctFiles, this.currUploadedFilenames),
      perfect: notExpected.length + notSupplied.length == 0
    };
  },

  formatFileCheck: function(fileCheck) {
    var s = "";
    if (fileCheck.notSupplied.length) {
      s +=
        "Warning - The following expected files were not supplied and will not be created or replaced:\n\n";
      _.each(fileCheck.notSupplied, function(filename) {
        s += filename + "\n";
      });
    }
    if (fileCheck.notExpected.length) {
      s +=
        "\nWarning - The following files were not expected and will be ignored:\n\n";
      _.each(fileCheck.notExpected, function(filename) {
        s += filename + "\n";
      });
    }

    if (fileCheck.toBeReplaced.length) {
      s += "\nThe following assets will be replaced:\n\n";
      _.each(fileCheck.toBeReplaced, function(filename) {
        s += filename + "\n";
      });
    }

    if (fileCheck.toBeCreated.length) {
      s += "\nThe following assets will be created:\n\n";
      _.each(fileCheck.toBeCreated, function(filename) {
        s += filename + "\n";
      });
    }

    s += "\n\nAre you sure you want to go ahead?";
    return s;
  },

  fetchAssetData: function() {
    var view = this;
    view.currUploadedAssetIds = _.map(this.$selectElement.val(), function(val) {
      return parseInt(val);
    });
    if (view.currUploadedAssetIds != null) {
      var assetIdsCsv = view.currUploadedAssetIds.join(",");

      $.get(
        "/api/core/assets/get_batch/?page_size=1000",
        { ids: assetIdsCsv },
        function(data) {
          view.currUploadedAssets = data.results;
          view.currUploadedFilenames = [];
          _.each(view.currUploadedAssets, function(asset) {
            view.currUploadedFilenames.push(
              stripExtension(asset.original_filename)
            );
          });
        }
      );
    } else {
      view.currUploadedAssetIds = [];
    }
  }
});

var BulkUploadView = BaseView.extend({
  initialize: function() {
    var view = this;

    this.$fileInput = $('<input type="file" multiple />');
    var $fileInput = this.$fileInput;
    $fileInput.appendTo(this.$el);

    const replaceConfirmTemplate = require("../nunjucks-templates/asset-replace-confirm.html");

    $fileInput.on("change", function() {
      startMainLoading();
      //TODO: if html5 FileApi is not supported, then assume only one file could be uploaded at a time

      var files = this.files;

      var selectedFiles = []; //to be sent to the server to generate forms
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        selectedFiles.push({
          js_id: i,
          name: file.name,
          size: file.size,
          type: file.type
        });
      }
      var selectedFilenames = _.map(selectedFiles, function(file) {
        return file.name;
      });
      view.fetchAssetData(selectedFilenames, function(assets) {
        var filenamesToBeReplaced = [];
        _.each(assets, function(asset) {
          filenamesToBeReplaced.push(asset.original_filename);
        });
        var notExpected = _.difference(
          selectedFilenames,
          filenamesToBeReplaced
        );

        var filesToUpload = [];
        _.each(filenamesToBeReplaced, function(filename) {
          _.each(selectedFiles, function(file) {
            if (file.name == filename) {
              filesToUpload.push(file);
            }
          });
        });

        var fileUploadsLeft = filesToUpload.length;

        var $confirmBox = $(
          replaceConfirmTemplate.render({
            toBeReplaced: filenamesToBeReplaced,
            notExpected: notExpected
          })
        );

        $confirmBox.find(".cancel-button").on("click", function() {
          $confirmBox.ensoModal("destroy");
        });
        $confirmBox.find(".ok-button").on("click", function() {
          $confirmBox.ensoModal("destroy");

          var createAssetsUrl = "/asset/create-update-multiple/";
          $.ajax({
            type: "POST", // semantically it should be GET, but the payload is often too large for nginx/UWSGI to handle
            url: createAssetsUrl,
            data: {
              "file-data": JSON.stringify(filesToUpload),
              type: "GET"
            } //encode json as a querystring parameter
          }).done(function(response) {
            var $assetsWrapper = $(response);
            var $saveAssetsBtn = $assetsWrapper.find("#save-assets-btn");
            $saveAssetsBtn.addClass("disabled");
            $assetsWrapper.ensoModal(); //open the modal
            var fileUploadUrl = $assetsWrapper.data("file-upload-url");
            var createAssetsUrl = $assetsWrapper.data(
              "asset-create-multiple-url"
            );

            var $uploadWidgets = $assetsWrapper.find("[js-asset-upload]");

            // now that we have server side generated uuid's for the files, we can upload them
            //TODO: don't just upload them all at once, do a maximum of 3 or so at a time
            $uploadWidgets.each(function(i, e) {
              var $uploadWidget = $(e);
              var $progressBar = $uploadWidget.find(
                "[js-progress] .progress-bar"
              );
              var uuid = $uploadWidget.data("uuid");

              // upload the file asynchronously wile the user fills out the rest of the form
              var fileUploadFormData = new FormData(
                $uploadWidget.find("form.file-upload-form")[0]
              );
              var file = files[parseInt($uploadWidget.data("js-id"))];
              var mimeType = getMimeObject(file.type);
              fileUploadFormData.append("file", file);

              var xhr = new window.XMLHttpRequest();
              xhr.open("POST", fileUploadUrl);
              xhr.onload = function(event) {
                fileUploadsLeft--;
                if (fileUploadsLeft == 0) {
                  $saveAssetsBtn.removeClass("disabled");
                }
              };

              xhr.upload.onprogress = function(event) {
                if (!event.lengthComputable) {
                  return; //TODO: in this case we should turn the progress meter into a 'spinner' type view
                }
                // Update file size because it might be bigger than reported by the fileSize:
                var percentComplete = event.loaded / event.total * 100.0;
                $progressBar.css("width", percentComplete + "%");
              };

              setTimeout(function() {
                xhr.send(fileUploadFormData);
              }, 500);

              // show a preview of the file using html5 FileReader

              var fileReader = new FileReader();

              fileReader.onload = function(e) {
                uri = e.target.result;
                switch (mimeType.mediaType) {
                  case "image":
                    var $previewImage = $uploadWidget.find(
                      "[js-image-preview]"
                    );
                    $previewImage.attr("src", uri);
                    break;
                  case "audio":
                    var $previewAudio = $uploadWidget.find(
                      "[js-audio-preview]"
                    );
                    var uri = e.target.result;
                    //$previewAudio.find('source')[0].src = uri;
                    //$previewAudio[0].load();
                    break;
                  case "video":
                    var $previewVideo = $uploadWidget.find(
                      "[js-video-preview]"
                    );
                    var uri = e.target.result;
                    //$previewVideo.find('source')[0].src = uri;
                    //$previewVideo[0].load();
                    break;
                }
              };
              fileReader.readAsDataURL(file);

              // seeing as the page has multiple of the same form and it's
              // a hassle to have to namespace each field by appending a number (title-1, title-2, etc)
              // we are going to serialise each form as a JSON structure where the key to each object
              // is the uuid for the file. This will be posted as a single querystring parameter 'data'
            });

            $saveAssetsBtn.on("click", function(e) {
              // don't let the user save until all files have been uploaded
              if (!$(this).hasClass(".disabled")) {
                startMainLoading();
                e.preventDefault();

                var allFormData = {};

                $uploadWidgets.each(function() {
                  var $widget = $(this);
                  var $form = $widget.find(".asset-metadata-form");
                });

                $assetsWrapper.find(".asset-metadata-form").each(function() {
                  var $form = $(this);
                  var formData = $form.serializeObject();
                  formData.related_ap_object_pk = initial_data.ap_object_pk;
                  allFormData[formData.uuid] = formData;
                });

                $.ajax({
                  type: "POST",
                  url: createAssetsUrl,
                  data: { data: JSON.stringify(allFormData) }
                }).done(function(response) {
                  $assetsWrapper.ensoModal("destroy");

                  var uploadedAssets = response.assets;
                  var uploadedFilenames = [];
                  _.each(uploadedAssets, function(asset) {
                    uploadedFilenames.push(
                      stripExtension(asset.original_filename)
                    );
                  });
                  var uploadedAssetIds = [];
                  _.each(uploadedAssets, function(asset) {
                    uploadedAssetIds.push(asset.id);
                  });
                  var newAssetIds = _.difference(
                    uploadedAssetIds,
                    view.currUploadedAssetIds
                  );
                  // add option elements for these, we don't really care what the label is as it won't be seen
                  stopMainLoading();
                  alert("done");
                  window.location.reload();
                });
              }
            });
          });
        });
        $confirmBox.ensoModal();
        stopMainLoading();
      });
    });
  },

  fetchAssetData: function(filenames, callback) {
    var view = this;
    filenamesJson = JSON.stringify(filenames);

    $.get(
      "/api/core/assets/get_batch/?page_size=1000",
      { "original-filenames": filenamesJson },
      function(data) {
        view.currUploadedAssets = data.results;
        callback(data.results);
      }
    );
  }
});

var ImageAssetInputWidgetView = BaseView.extend({
  initialize: function() {
    var view = this;
    view.fileUuid = null;
    view.$fileInput = this.$el.find("#id_file");
    view.fileUploadUrl = view.$el.data("file-upload-url");
    view.$progressBar = view.$el.find("[js-progress] .progress-bar");
    view.$parentForm = view.$el.closest("form");
    view.$submitBtn = view.$parentForm.find(".submit-btn");
    view.$parentForm.prepend('<input type="hidden" name="file-uuid" value="">');
    view.$hiddenUuidField = view.$parentForm.find("input[name=file-uuid]");
    view.csrfmiddlewaretoken = view.$parentForm
      .find("[name=csrfmiddlewaretoken]")
      .val();
    view.uploading = false;

    //        view.$parentForm.on('submit', function (e) {
    //            if (view.uploading) {
    //                e.preventDefault();
    //                alert('please wait for the file to upload before submitting');
    //            }
    //        });

    view.$fileInput.on("change", function() {
      view.$submitBtn.addClass("disabled");
      view.fileUuid = get_uuid();
      view.$hiddenUuidField.val(view.fileUuid);

      var file = this.files[0];
      if (!_.contains(ALLOWED_FILE_TYPES, file.type)) {
        alert(
          "Unfortunately the file " +
            file.name +
            " cannot be uploaded as the type " +
            file.type +
            " is not supported"
        );
        return;
      }

      //so now we set the value of the <input> element to null, as we
      // don't want to use it to upload the file (file upload happens in the background
      // via Ajax)
      var $clonedFileInput = view.$fileInput.clone(true);
      view.$fileInput.replaceWith($clonedFileInput); //http://stackoverflow.com/questions/1043957/clearing-input-type-file-using-jquery
      //            view.$fileInput.hide();
      view.$fileInput = $clonedFileInput;
      view.$fileInput.hide();

      // upload the file asynchronously wile the user fills out the rest of the form
      var fileUploadFormData = new FormData();
      fileUploadFormData.append(
        "csrfmiddlewaretoken",
        view.csrfmiddlewaretoken
      );
      fileUploadFormData.append("uuid", view.fileUuid);
      fileUploadFormData.append("file", file);

      var xhr = new window.XMLHttpRequest();
      xhr.open("POST", view.fileUploadUrl);
      xhr.onload = function(event) {
        view.uploading = false;
        view.$submitBtn.removeClass("disabled");
      };

      view.uploading = true;

      xhr.upload.onprogress = function(event) {
        if (!event.lengthComputable) {
          return; //TODO: in this case we should turn the progress meter into a 'spinner' type view
        }
        // Update file size because it might be bigger than reported by the fileSize:
        var percentComplete = event.loaded / event.total * 100.0;
        view.$progressBar.css("width", percentComplete + "%");
      };

      setTimeout(function() {
        xhr.send(fileUploadFormData);
      }, 500);
    });
  }
});

var ImageCropperView = Backbone.View.extend({
  defaultOptions: {
    initialSelection: null,
    aspectRatio: 1.0,
    onreadyCallback: null,
    submitCallback: null
  },

  events: {
    submit: "submit"
  },

  initialize: function(options) {
    var view = this;
    view.cropPaddingHorz = 250;
    view.cropPaddingVert = 50;
    view.options = Object.assign({}, view.defaultOptions, options);
    console.log("image cropper view options", view.options);

    var coords;

    view.$image = $("<img>");
    view.$image.attr("src", view.options.imageUrl);

    view.$image.on("load", function() {
      var tmpl = require("../nunjucks-templates/cropper.html");
      var html = tmpl.render({ title: view.options.title });
      var $cropper = $(html);
      view.$image.appendTo($cropper.find(".canvas"));

      view.imageWidth = view.$image[0].width;
      view.imageHeight = view.$image[0].height;

      $cropper.appendTo(view.$el);

      if (view.options.onreadyCallback) {
        view.options.onreadyCallback();
      }
      view.$el.html();
    });
  },

  submit: function(e) {
    var view = this;
    e.preventDefault();
    if (view.options.submitCallback) {
      view.options.submitCallback(view.coords);
    }
  },

  /**
   * Jcropt can only be initialise after the html has been rendered to the dom.
   * so if you are dynamically generating and rendering outer html, then you
   * need to call this function after you've rendered it to screen
   */
  initJcrop: function() {
    var jcropApi;
    var view = this;
    var initialSelection = view.options.initialSelection;

    var _onchangeCallback = function(c) {
      view.coords = {
        topLeft: {
          x: c.x,
          y: c.y
        },
        bottomRight: {
          x: c.x2,
          y: c.y2
        }
      };
      if (view.options.onchangeCallback) {
        view.options.onchangeCallback(coords);
      }
    };

    var PADDING_VERT = 150;
    var PADDING_HORZ = 250;

    var options = {
      aspectRatio: view.options.aspectRatio,
      //onSelect: showCoords,
      onChange: _onchangeCallback,
      paddingVert: PADDING_VERT, //this is a custom feature of the forked Jcrop
      paddingHorz: PADDING_HORZ
    };

    if (view.options.aspectRatio != null) {
      options.aspectRatio = view.options.aspectRatio;
    }

    view.$image.Jcrop(options, function() {
      jcropApi = this;
      if (initialSelection) {
        console.log("initialSelection", initialSelection);
        jcropApi.setSelect([
          initialSelection.topLeft.x + PADDING_HORZ,
          initialSelection.topLeft.y + PADDING_VERT,
          initialSelection.bottomRight.x + PADDING_HORZ,
          initialSelection.bottomRight.y + PADDING_VERT
        ]);
      }
    });
  },

  normalisePoint: function(point) {
    var view = this;
    return {
      x: point.x / view.imageWidth,
      y: point.y / view.imageHeight
    };
  },

  getNormalisedCoords: function() {
    var view = this;
    return {
      topLeft: view.normalisePoint(view.coords.topLeft),
      bottomRight: view.normalisePoint(view.coords.bottomRight)
    };
  }
});

var MultimediaFormView = BaseView.extend({
  initialize: function() {
    var view = this;
    view.$multimediaSelect = view.$("#id_multimedia_type");
    view.render();
  },

  events: {
    "change #id_multimedia_type": function(e) {
      var view = this;
      view.render();
    },

    submit: function(e) {
      var view = this;
      view.$multimediaSelect.prop("disabled", false);
      return;
    }
  },

  render: function() {
    var view = this;
    view.selectedType = view.$multimediaSelect
      .val()
      .toLowerCase()
      .trim();
    if (view.selectedType == "" || view.selectedType == "  ") {
      //'  ' is because of wierd bug I can't explain
    } else {
      view.$(".reveal").show();
      view.$("." + view.selectedType).show();
      view.$multimediaSelect.prop("disabled", true);
    }
  }
});

/******************************************************************************
 ** Page specific initilisation
 ******************************************************************************/
// code that we only want initialized/executed when we are on specific pages
// the current page is determined by $('.body').data('page-slugs')
// a page can have multiple page slugs

var ensoEditorView;

/**
 * this should be called after any pages are loaded via ajax
 * TODO: this should be scoped to an element. Eg if a div is loaded
 * into a popup, only plugins inside the popup should be initialized, or
 * else elements will be initialized multiple times
 */
var initializePluginsAndWidgets = function() {
  $("[js-tab-set]").tabSet();
};

var pages = {
  all: function() {
    $("[js-prevent-double-click]").preventDoubleClick();

    $(".fullscreen-spinner .spinner").spin({
      lines: 11, // The number of lines to draw
      length: 9, // The length of each line
      width: 4, // The line thickness
      radius: 6, // The radius of the inner circle
      corners: 1, // Corner roundness (0..1)
      rotate: 0, // The rotation offset
      direction: 1, // 1: clockwise, -1: counterclockwise
      //color: '#FFF' // #rgb or #rrggbb or array of colors
      color: "#333"

      //speed: 1, // Rounds per second
      //trail: 60, // Afterglow percentage
      //shadow: false, // Whether to render a shadow
      //hwaccel: false, // Whether to use hardware acceleration
      //className: 'spinner', // The CSS class to assign to the spinner
      //zIndex: 2e9, // The z-index (defaults to 2000000000)
      //top: 'auto', // Top position relative to parent in px
      //left: 'auto' // Left position relative to parent in px
    });

    $("[js-foreign-key-widget]").each(function(i, el) {
      new ForeignKeyWidgetView({ el: el });
    });

    $("[js-multiple-assets-widget]").each(function(i, el) {
      new MultipleAssetsView({ el: el });
    });

    $("[js-image-input-widget]").each(function(i, el) {
      new ImageAssetInputWidgetView({ el: el });
    });

    $("[js-image-asset-widget]").each(function(i, el) {
      new ImageAssetWidgetView({ el: el });
    });

    $("[js-media-asset-widget]").each(function(i, el) {
      new MediaAssetWidgetView({ el: el });
    });

    $("[js-asset-manager-panel]").each(function(i, el) {
      new AssetManagerPanelView({ el: el });
    });

    $("[js-image-gallery-edit]").each(function(i, el) {
      new GalleryEditView({ el: el });
    });

    // // WARNING: extremely ugly code ahead. It assumes there is only
    // // one 'enso-editor' (blog post) on the page
    // $('.enso-editor').each(function (i, el) {
    //     ensoEditorView = new EnsoEditorView({
    //         textareaSelector: '.enso-editor'
    //     });
    // });

    (function() {
      // select all checkboxes toggle  // TODO: make it a jquery plugin
      var $btn = $("#select-all-checkboxes");

      $btn.on("click", function() {
        var $form = $btn.closest("form");
        var $checkboxes = $form.find("tbody .selection input[type=checkbox]");
        var $selectedCheckboxes = $form.find(
          "tbody .selection input[type=checkbox]:checked"
        );
        if ($checkboxes.length === $selectedCheckboxes.length) {
          // uncheck all
          $btn.prop("checked", false);
          $selectedCheckboxes.prop("checked", false);
        } else {
          $btn.prop("checked", true);
          $checkboxes.prop("checked", true);
        }
      });
    })();

    // render the (accessible) actions select with buttons interface as a
    // dynamic drop down in the left column
    var $oldUi = $("[js-accessible-actions-ui]");
    var $select = $oldUi.find("select");
    var $newUi = $('<ul class="actions-dropdown">');
    var $form = $oldUi.closest("form");
    $oldUi.find("option").each(function(i, e) {
      var $option = $(e);
      if ($option.val() != "") {
        var $li = $("<li>")
          .append('<a href="">' + $option.text() + "</a>")
          .appendTo($newUi);
        $li.on("click", function(e) {
          e.preventDefault();
          $select.val($option.val());
          $form.submit();
        });
      }
    });
    $("[js-actions-ui]")
      .append($newUi)
      .ensoVerticalDropdown();

    $("[js-vertical-drop-down]").ensoVerticalDropdown();

    $(".is-live").tooltip();

    initializePluginsAndWidgets();
  },

  "ap-object-list": function() {
    $("#new-object-btn").on("click", function(e) {
      e.preventDefault();
      var url = $(this).attr("href");
      openFormModal(
        { url: url },
        function(apObject) {
          apObject.id;
          window.location.href = "/object/" + apObject.id + "/update/";
        },
        function() {
          $("#id_maker").chosen({
            no_results_text: "no results matched"
          });
        }
      );
    });
  },

  "media-item-create-update": function() {
    globalEvents.on("enso:assetChanged", function(data) {
      $("#id_title").val(data.generated_title);
    });
  },

  "ap-object": function() {
    $("[js-overview-image-link]").magnificPopup({ type: "image" });
  },

  "ap-object-create-update": function() {
    $("#id_maker").chosen({
      no_results_text:
        "no results matched. click the plus button to add a maker."
    });

    mainImageData = {};
    if (typeof initial_data !== "undefined" && "main_image" in initial_data) {
      var mainImageData = initial_data.main_image;
    }
    new MainImageAssetWidgetView({
      model: new ImageAssetModel(mainImageData),
      el: $("#main-image").get(0)
    });
  },

  "ap-object-content-list": function() {
    //todo: get this from the inner widget

    if (jQuery.fn.sortable) {
      //don't break the site if we forget to include the plugin!
      // ../jquery-plugins/ui/js/jquery-ui-1.9.2.custom.min.js
      $(".content-items tbody").sortable({
        axis: "y",
        stop: function(event, ui) {
          var $contentItems = ui.item.closest(".content-items");
          sendNewOrdering($contentItems);
        }
      });
    } else {
      console.warn("jQuery.fn.sortable not loaded");
    }

    function sendNewOrdering($contentItems) {
      var itemIds = [];
      $contentItems.find("tbody tr").each(function() {
        itemIds.push($(this).attr("data-item-id"));
      });
      //                $.ajax
      $.ajax({
        type: "POST",
        url: "/object/reorder-content-items/",
        data: { new_ordering: JSON.stringify(itemIds) }
      }).done(function(response) {});
    }
  },

  "image-asset-create-update": function() {
    $("[js-tabbed-fieldsets]").tabbedFieldsets();
  },

  //    'audio-asset-create-update': function() {
  //        $('[js-tabbed-fieldsets]').tabbedFieldsets();
  //    },
  //
  //    'video-asset-create-update': function() {
  //        $('[js-tabbed-fieldsets]').tabbedFieldsets();
  //    },

  "ap-collection-create-update": function() {
    $("[js-image-asset-widget]").each(function(i, el) {
      new ImageAssetWidgetView({ el: el });
    });
  },

  "upload-and-replace-files": function() {
    $("[js-bulk-upload-widget]").each(function(i, el) {
      new BulkUploadView({ el: el });
    });
  },

  //TODO: figure out away to isolate this inside the django plugin module (this shouldn't be seen by apps not including the 'apcm_multimedia' module
  "multimedia-create-update": function() {
    new MultimediaFormView({
      el: $(".multimedia-create-update #content-main form")[0]
    });
  }
};

var currPageSlugs = $body.data("page-slugs").split(" "); //an array of page names (page may have multiple names for different levels of abstraction)

pages["all"]();
$.each(pages, function(pageSlug, pageInitializationFunction) {
  if (_.contains(currPageSlugs, pageSlug)) {
    pageInitializationFunction();
  }
});

/******************************************************************************
 ** initial Backbone model instances
 ******************************************************************************/

var bodyView = new BodyView();

var mainImage = null; //TODO: this only applies to ap object create view

/******************************************************************************
 ******************************************************************************/



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/main.js